import React, { Suspense, lazy } from 'react';
import { HeroSection } from './components/HeroSection';
const BelowFold = lazy(() => import('./components/BelowFold').then(m => ({
  default: m.BelowFold
})));
export function App() {
  return <div className="min-h-screen bg-navy-950 text-slate-200 font-inter selection:bg-purple-500/30 overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <Suspense fallback={<div className="min-h-[200px] flex items-center justify-center" data-id="element-3">
            <div className="w-8 h-8 border-4 border-purple-500/30 border-t-purple-500 rounded-full animate-spin" data-id="element-4" />
          </div>} data-id="element-2">
        <BelowFold data-id="element-5" />
      </Suspense>
    </div>;
}